// extracted by mini-css-extract-plugin
module.exports = {"recaptchaMessage":"styles_recaptchaMessage__2CI3C"};